export default "__VITE_ASSET__CTz5x0cN__"